import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Pagination, Box, Typography} from '@mui/material';
import {getLogs} from '../actions';
import LogsTable from '../components/CustomTables/LogsTable';
import {Filters} from '../components';
import useFilters from '../utils/useFilters';

const LogsPage = () => {
  const dispatch = useDispatch();
  const {logs, logsTotalPages, logsPage, logsLoading} = useSelector(
    s => s.reports,
  );
  // Logs are only loaded once an elevator is selected (the unfiltered query is
  // too broad to be useful and expensive on the logs table).
  const filters = useFilters(val => {
    if (val.elevatorId) dispatch(getLogs(val));
  }, 'imei');
  const hasElevator = !!filters.elevator;

  const onPageChange = (e, value) => {
    dispatch(getLogs({page: value, ...filters.filters}));
  };

  return (
    <>
      <Filters
        withSearch
        withElevator
        withDateRange
        searchLabel="Search by IMEI"
        {...filters}
      />
      {hasElevator ? (
        <LogsTable logs={logs} loading={logsLoading} />
      ) : (
        <Box mt="2rem" textAlign="center">
          <Typography color="textSecondary">
            Select an elevator to see its logs.
          </Typography>
        </Box>
      )}
      {hasElevator && logsTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={logsTotalPages}
            page={logsPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </>
  );
};

export default LogsPage;
